/**
 * Analytics calculation utilities.
 * Extracted from AnalyticsInsights, AnalyticsInsightsTwoFactor, and AnalyticsFeedback components.
 */

/**
 * Calculates the impact score based on percentage difference and average count.
 * @param percent - Percentage difference (e.g., from calculateDelta)
 * @param average_n - Average count/number
 * @returns Impact score
 */
export const calculateImpact = (percent: number, average_n: number): number => percent * average_n;

/**
 * Calculates the percentage difference (delta) between a score and a norm.
 * @param score - The actual score
 * @param norm - The norm/reference score
 * @returns Percentage difference (positive = above norm, negative = below norm)
 */
export const calculateDelta = (score: number, norm: number): number => {
  if (norm === 0) return 0;
  return (score / norm - 1) * 100;
};

/**
 * Calculates risk score based on score and feedback sentiment.
 * @param score - The score value (0-10 scale typically)
 * @param feedback - The feedback text to analyze
 * @param sentimentAnalyzer - Sentiment analyzer instance (from Sentiment library)
 * @returns Risk score (0-100 scale)
 */
export const calculateRisk = (
  score: number,
  feedback: string,
  sentimentAnalyzer: {
    analyze: (text: string) => {
      score: number;
      calculation: number[];
    };
  }
): number => {
  const sent = sentimentAnalyzer.analyze(feedback);
  const sent_score =
    sent.calculation.length > 0 ? sent.score / sent.calculation.length : sent.score;

  return Math.floor(50 - score * 5 + (sent_score * -1 + 5) * 5);
};

